import { Dispatch } from 'redux'
import { UserService } from 'services/user.service';

export const getTenantDetails: any = () => async (dispatch: Dispatch, getState: any) => {
    try {
        const state = getState()?.user;
        const loading = state?.tenantsLoading;
        const existing = state?.tenants || [];
        if (loading || (Array.isArray(existing) && existing.length > 0)) {
            return existing;
        }
        dispatch({ type: 'GET_TENANTS_LOADING' });
        const res = await UserService.getTenants();
        if(!res) {
            dispatch({ type: 'GET_TENANTS_ERROR' });
            throw new Error('Error on fetching tenants');
        }
        const data = (res?.value as any)?.data;
        dispatch({ type: 'GET_TENANTS_COMPLETED', payload: data });
        return data;
    } catch(e: any) {
        const status = e?.response?.status;
        const code = e?.response?.data?.error || e?.response?.data?.detail;
        dispatch({ type: 'GET_TENANTS_ERROR', payload: { status, code } });
        // Re-throw so the calling component (LandingPage / Header) can react to
        // 401 authentication_required or 403 identity_mismatch and force a
        // re-login.
        throw e;
    }
}

export const setCurrentTenant = (tenant: any) => ({ type: 'SET_CURRENT_TENANT', payload: tenant });

